// extracted by mini-css-extract-plugin
export default {"integrationErrors":"integrationErrors_integrationErrors__6GX0F"};